import { useDispatch } from 'react-redux';

import { setSnackbar } from '../../redux/snackbar';

export default function Error(msg) {
  const dispatch = useDispatch();

  return (message = msg || 'Erro ao submeter ação!') => {
    dispatch(setSnackbar(true, 'error', message));
  };
}
